import {WizRequestOptions} from '@/interface';
import {random} from 'lodash-es';
import queryString from 'query-string';

export type IAddFrontTraceInfo = (opt: WizRequestOptions) => WizRequestOptions;

export function addFrontTraceInfo(opt: WizRequestOptions) {
    const timestamp = +new Date();
    const randomNumber = random(1000, 9999);
    const buildId = process.env.REACT_APP_BUILD_ID;
    // @ts-ignore
    const sliceUserGuid = this ? (this.as.user?.userGuid || '').slice(-4) : '';
    const traceId = `${timestamp}_${randomNumber}_${buildId}_${sliceUserGuid}`;
    const url = queryString.stringifyUrl({
        url: opt.url || '',
        query: {
            'front_traceId': traceId,
        },
    });
    return {
        ...opt,
        url,
        headers: {
            ...opt.headers,
            'front-traceId': traceId,
        },
    };

}
